import React from 'react';
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const PseudoAnonymizerHelp = ({ t }) => {
  const [open, setOpen] = React.useState(true);
  const collapseId = 'pseudo-anonymizer-help';

  return (
    <Alert
      icon={<HelpOutlineIcon sx={{ mt: 0.5 }} />}
      severity="info"
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: 2,
        '& .MuiAlert-message': { width: '100%' },
        py: 1.5,
        px: 2,
      }}
      action={
        <IconButton
          size="small"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls={collapseId}
          aria-label={open ? 'collapse' : 'expand'}
          sx={{ mt: 0.5, color: 'inherit' }}
        >
          {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      }
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
        {t?.('PseudoAnonymizerPage.help.title', 'Ako to funguje')}
      </Typography>

      <Collapse in={open} timeout="auto" id={collapseId}>
        <Stack spacing={1.5} sx={{ mt: 1.5 }}>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'PseudoAnonymizerPage.help.p1',
              'Pseudonymizácia je proces, pri ktorom systém v dokumente DOCX nahradí osobné údaje (podľa zvoleného profilu pseudonymizácie) zašifrovanými reťazcami.'
            )}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'PseudoAnonymizerPage.help.p2',
              'Takto upravený dokument môžete ďalej meniť - dopĺňať, odoberať alebo formátovať text - pričom osoba, ktorá dokument spracúva, nevidí pôvodné (pseudonymizované) údaje.'
            )}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'PseudoAnonymizerPage.help.p3',
              'Po finálnej korektúre je možné vrátiť do dokumentu všetky zašifrované údaje použitím procesu depseudonymizácie. Výsledkom je nový súbor s pôvodnými údajmi.'
            )}
          </Typography>

          <Box 
            sx={(theme) => ({ 
              mt: 1, 
              p: 1.5, 
              borderRadius: 1.5,
              border: '1px dashed',
              borderColor: 'info.main',
              bgcolor: alpha(theme.palette.info.main, 0.08)
            })}
          >
            <Typography variant="body2" sx={{ display: 'block', fontWeight: 600, color: 'info.main' }}>
              💡 {t?.('PseudoAnonymizerPage.help.tipsTitle', 'Tipy')}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
              • {t?.(
                'PseudoAnonymizerPage.help.tip1',
                'Vyberte si profil pseudonymizácie podľa toho, aký rozsah údajov potrebujete v dokumente skryť.'
              )}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25, lineHeight: 1.5 }}>
              • {t?.(
                'PseudoAnonymizerPage.help.tip2',
                'Depseudonymizáciu použite až po finálnej korektúre - výsledkom bude nový DOCX s pôvodnými údajmi.'
              )}
            </Typography>
          </Box>
        </Stack>
      </Collapse>
    </Alert>
  );
};

export default PseudoAnonymizerHelp;